@let navbarGroups = metaData()['navbarGroups'];

<div [formGroup]="form">
    <app-website-config-form-expansion-panel [title]="'Unterseiten'" [firstMarginTop]="true">
        <div formArrayName="pages">
            @for (pageGroup of pagesArray.controls; let i = $index; track pageGroup) {
            <div [formGroup]="pageGroup" class="admin-row no-border-bottom">

                @let disabled = !pageGroup.get('isEditable')?.value;
                <!-- @let disabled = false; -->

                <mat-form-field appearance="outline"class="form-field-width cell">
                    <mat-label>Seitenname</mat-label>
                    <input matInput formControlName="name">
                    @if(pageGroup.get('name')?.hasError('required')) {
                    <mat-error>Feld darf nicht leer sein</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline"class="form-field-width cell">
                    <mat-label>URL</mat-label>
                    <input matInput formControlName="url">
                    @if(pageGroup.get('url')?.hasError('duplicateUrl')) {
                        <mat-error>{{ pageGroup.get('url')?.getError('duplicateUrl') }}</mat-error>
                    } @else if (pageGroup.get('url')?.hasError('required')) {
                        <mat-error>Feld darf nicht leer sein</mat-error>
                    } @else if (pageGroup.get('url')?.hasError('invalidPath')) {
                        <mat-error>{{ pageGroup.get('url')?.getError('invalidPath') }}</mat-error>
                    }
                </mat-form-field>

                <mat-checkbox class="cell" formControlName="isInNavbar">In Navigationsleiste anzeigen</mat-checkbox>

                @if(pageGroup.get('isInNavbar')?.value) {
                <mat-form-field appearance="outline"class="form-field-width cell">
                    <mat-label>In Gruppe</mat-label>
                    <mat-select formControlName="navbarGroup" panelClass="admin-theme">
                        <mat-option [value]="null">Keine Gruppe</mat-option>
                        @for (group of navbarGroups; track group) {
                        <mat-option [value]="group.id">{{ group.displayName }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                } @else {
                <div class="cell"></div>
                }
                <button mat-icon-button (click)="onDeletePage(i)" [disabled]="disabled">
                    <mat-icon ngClass="{{ disabled ? '' : 'admin-error' }}">delete</mat-icon>
                </button>

            </div>
            <mat-divider></mat-divider>
            }
        </div>
        <div class="add-action">
            <button mat-mini-fab (click)="addPage()">
                <mat-icon class="admin-success">add</mat-icon>
            </button>
        </div>
    </app-website-config-form-expansion-panel>

    <app-website-config-form-expansion-panel [title]="'Gruppen'">
        <div formArrayName="navbarGroups">
            @for (group of navbarGroupArray.controls; track group; let i = $index; let last = $last) {
            <div [formGroup]="group" class="admin-row no-border-bottom">
                <mat-form-field appearance="outline"class="form-field-width cell">
                    <mat-label>Gruppenname</mat-label>
                    <input matInput type="text" formControlName="displayName" (input)="onInputChange(i, $event)">
                </mat-form-field>
                <button mat-icon-button (click)="onDeleteNavbarGroup(i)">
                    <mat-icon class="admin-error">delete</mat-icon>
                </button>
            </div>
            <mat-divider></mat-divider>
            }
        </div>
        <div class="add-action">
            <button mat-mini-fab (click)="addNavbarGroup()">
                <mat-icon class="admin-success">add</mat-icon>
            </button>
        </div>
    </app-website-config-form-expansion-panel>
</div>